<template>
    <div class="page">
        <IndexHeader />

        <main class="page-main">
            <!-- 关于我们 -->
            <section class="about-card">
                <div class="about-head">
                    <span class="badge">
                        <team-outlined />
                        关于我们
                    </span>
                    <h2 class="about-title">易售SUP云科技</h2>
                    <p class="about-desc">
                        易售SUP致力于为每一个顾客提供最稳定的产品，最优质的服务，期待与您并行，共担未来。
                    </p>
                    <p class="about-desc">易售SUP云科技的核心业务主要涉及软件程序领域的研发和应用。</p>
                </div>

                <div class="about-contacts">
                    <div class="contact-item">
                        <customer-service-outlined />
                        <div class="contact-text">
                            <span class="contact-label">TG唯一官方客服</span>
                            <span class="contact-value">@yishousup</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <notification-outlined />
                        <div class="contact-text">
                            <span class="contact-label">TG通知群</span>
                            <span class="contact-value">t.me/+y2H6Yn1AEwEzMjZl</span>
                        </div>
                    </div>
                    <div class="contact-item">
                        <read-outlined />
                        <div class="contact-text">
                            <span class="contact-label">安装教程</span>
                            <span class="contact-value">download.yishou.shop/help.html</span>
                        </div>
                    </div>
                </div>

                <img src="/img/about1.jpg" class="about-image" alt="关于我们">
            </section>

            <!-- 我的合作伙伴 -->
            <section class="partners-card">
                <div class="section-head">
                    <h2>我的合作伙伴</h2>
                    <p>合作伙伴与本站携手创造未来，携手发展信息时代，营造一个美好的互联网时代，制作出更符合人心的应用产品，走向新的未来</p>
                </div>
                <div class="partners-grid">
                    <img src="/img/index_case_logos1.png" alt="合作伙伴">
                </div>
            </section>

            <!-- 我的使命 -->
            <section class="mission-card">
                <div class="section-head">
                    <h2>我的使命</h2>
                    <p>易售SUP云科技的愿景和使命是利用先进的技术和创新的解决方案，推动数字化转型，为客户提供高效、可靠的应用验证和新型官网程序，帮助他们实现业务增长和创新。</p>
                    <p>易售SUP云科技以创新为核心，不断推动技术前沿的探索和应用，为客户提供高质量的产品和服务。</p>
                </div>
                <div class="mission-grid">
                    <div class="main-image">
                        <img src="/img/about2.jpg" alt="使命图片1">
                    </div>
                    <div class="sub-images">
                        <img src="/img/about3.jpg" alt="使命图片2">
                        <img src="/img/about4.jpg" alt="使命图片3">
                        <img src="/img/about5.jpg" alt="使命图片4">
                    </div>
                </div>
            </section>
        </main>

        <IndexFooter class="footer" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'

export default defineComponent({
    name: 'AboutView',
    components: {
        IndexHeader,
        IndexFooter
    }
})
</script>

<style scoped lang="scss">
.page {
    background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #f8fafc 100%);
    min-height: 100vh;
}

.page-main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 12vh 1.5rem 4rem;
    display: flex;
    flex-direction: column;
    gap: 3rem;
    height: 90vh;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
}

/* 卡片通用样式 */
.about-card,
.mission-card {
    background: #ffffff;
    border-radius: 1.6rem;
    padding: 2.5rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 20px 36px -26px rgba(15, 23, 42, 0.35);

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
}

/* 关于我们 */
.about-head {
    text-align: center;
    margin-bottom: 2rem;
}

.badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.3rem 0.9rem;
    border-radius: 9999px;
    background: rgba(37, 99, 235, 0.12);
    color: #1e40af;
    font-size: 0.85rem;
    font-weight: 600;
}

.about-title {
    font-size: 2rem;
    font-weight: 700;
    color: #0f172a;
    margin: 1rem 0 0.75rem;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
}

.about-desc {
    color: #64748b;
    line-height: 1.8;
    max-width: 800px;
    margin: 0 auto 0.5rem;
    font-size: 0.95rem;

    @media (max-width: 768px) {
        font-size: 0.88rem;
    }
}

.about-contacts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
}

.contact-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.25rem;
    border-radius: 1rem;
    background: #f8fafc;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 10px 18px -20px rgba(15, 23, 42, 0.3);

    .anticon {
        font-size: 1.4rem;
        color: #2563eb;
    }
}

.contact-text {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
}

.contact-label {
    font-size: 0.78rem;
    color: #94a3b8;
    font-weight: 500;
}

.contact-value {
    font-size: 0.92rem;
    color: #1e293b;
    font-weight: 600;
    word-break: break-all;
}

.about-image {
    width: 100%;
    height: auto;
    border-radius: 1.1rem;
    display: block;
    box-shadow: 0 14px 26px -18px rgba(15, 23, 42, 0.3);
}

/* 我的合作伙伴 */
.partners-card {
    background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
    border-radius: 1.6rem;
    padding: 2.5rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 18px 30px -24px rgba(15, 23, 42, 0.35);

    @media (max-width: 768px) {
        padding: 1.5rem;
    }
}

.section-head {
    text-align: center;
    margin-bottom: 1.8rem;

    h2 {
        font-size: 1.6rem;
        font-weight: 700;
        color: #0f172a;
        margin: 0 0 0.5rem;
    }

    p {
        color: #64748b;
        line-height: 1.7;
        max-width: 800px;
        margin: 0 auto;
    }
}

.partners-grid {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    background: #ffffff;
    border-radius: 1.1rem;
    border: 1px solid rgba(226, 232, 240, 0.9);

    img {
        max-width: 100%;
        height: auto;
    }
}

/* 我的使命 */
.mission-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.2rem;

    .main-image {
        grid-column: 1;
        grid-row: 1 / span 2;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 1rem;
        }
    }

    .sub-images {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.2rem;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.8rem;
        }
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;

        .main-image {
            grid-column: 1;
            grid-row: 1;
        }
    }
}

.footer {
    margin-top: 2rem;
}
</style>
